import { render, staticRenderFns } from "./ProjectAdditionalFields.vue?vue&type=template&id=501b2bfa&scoped=true&lang=pug&"
import script from "./ProjectAdditionalFields.vue?vue&type=script&lang=ts&"
export * from "./ProjectAdditionalFields.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectAdditionalFields.vue?vue&type=style&index=0&id=501b2bfa&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501b2bfa",
  null
  
)

export default component.exports